/*
  PP Quick Add — PLP card add-to-cart with selling plans.
  Figma 13788:9864 (desktop overlay), 14200:7 (mobile sheet).

  Nothing in this theme did selling plans from a card, so this owns the whole flow:
  read the plans Liquid emitted per card, let the shopper pick one, POST it to
  /cart/add.js with its selling_plan id, then open the theme's own cart drawer.

  Every click is delegated at document level on purpose. The collection grid is
  replaced wholesale when a filter or sort is applied, which would silently drop
  any listener bound directly to a card.
*/
(function () {
  'use strict';

  var SHEET_BP = window.matchMedia('(max-width: 749px)');

  /* ---------- plan data ---------- */

  function plansOf(card) {
    if (card._ppPlans) return card._ppPlans;
    var tag = card.querySelector('[data-ppc-plans]');
    if (!tag) return (card._ppPlans = []);
    try {
      card._ppPlans = JSON.parse(tag.textContent) || [];
    } catch (e) {
      // A malformed payload must not take the whole grid down with it
      console.warn('[ppqa] could not parse plans for', card.getAttribute('data-title'), e);
      card._ppPlans = [];
    }
    return card._ppPlans;
  }

  // The frames show a subscription preselected, so prefer the first real plan and
  // fall back to one-time only when the product has no plans at all.
  function defaultIndex(plans) {
    for (var i = 0; i < plans.length; i++) {
      if (plans[i].id) return i;
    }
    return 0;
  }

  function selectedIndex(card) {
    var n = parseInt(card.getAttribute('data-plan-idx'), 10);
    if (isNaN(n)) {
      n = defaultIndex(plansOf(card));
      card.setAttribute('data-plan-idx', n);
    }
    return n;
  }

  function setPlan(card, idx) {
    card.setAttribute('data-plan-idx', idx);
    paintCard(card);
  }

  /* ---------- per-card painting ---------- */

  function paintCard(card) {
    var plans = plansOf(card);
    if (!plans.length) return;
    var idx = selectedIndex(card);
    var plan = plans[idx] || plans[0];

    var label = card.querySelector('[data-ppc-select-label]');
    if (label) label.textContent = plan.name;

    var list = card.querySelector('[data-ppc-opts]');
    if (list && list.childElementCount) {
      Array.prototype.forEach.call(list.querySelectorAll('.ppc__opt'), function (b, i) {
        b.classList.toggle('is-selected', i === idx);
        b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    paintPrice(card, plan);
  }

  /* The card price follows whichever plan is chosen. Only products that actually have
     selling plans are affected: with none, the single entry is the one-time price and
     the original markup is simply restored. Bundles never reach here at all — link mode
     emits no data-ppc, so there is nothing to paint. */
  function paintPrice(card, plan) {
    var plans = plansOf(card);
    var item = card.closest('.product-item') || card.closest('.grid-item');
    if (!item) return;
    var priceEl = item.querySelector('.product-item__price');
    if (!priceEl) return;

    // keep the theme's own markup (sale/compare-at pair) so one-time can restore it
    if (!priceEl.hasAttribute('data-pp-price-orig')) {
      priceEl.setAttribute('data-pp-price-orig', priceEl.innerHTML);
    }

    if (plan && plan.id) {
      // the one-time price becomes the struck compare-at, per Figma 13792:12765
      var oneTime = null;
      for (var i = 0; i < plans.length; i++) {
        if (!plans[i].id) { oneTime = plans[i]; break; }
      }

      priceEl.textContent = '';
      var sp = document.createElement('span');
      sp.className = 'pp-price-plan';
      sp.textContent = plan.price;
      priceEl.appendChild(sp);

      // nothing to strike if the plan saves nothing
      if (oneTime && oneTime.price && oneTime.price !== plan.price) {
        var was = document.createElement('s');
        was.className = 'pp-price-was';
        was.textContent = oneTime.price;
        priceEl.appendChild(was);
      }
    } else {
      priceEl.innerHTML = priceEl.getAttribute('data-pp-price-orig');
    }
  }

  function buildOptions(card) {
    var list = card.querySelector('[data-ppc-opts]');
    if (!list || list.childElementCount) return;
    var plans = plansOf(card);
    var frag = document.createDocumentFragment();

    plans.forEach(function (plan, i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ppc__opt';
      b.setAttribute('role', 'option');
      b.setAttribute('data-ppc-opt', i);

      var name = document.createElement('span');
      name.className = 'ppc__opt-name';
      name.textContent = plan.name;

      var price = document.createElement('span');
      price.className = 'ppc__opt-price';
      price.textContent = plan.price;

      b.appendChild(name);
      b.appendChild(price);
      li.appendChild(b);
      frag.appendChild(li);
    });

    list.appendChild(frag);
    paintCard(card);
  }

  /* ---------- read more ---------- */

  // The shared card has no Read more of its own. Injecting it here keeps
  // product-grid-item free of a change that is purely presentational.
  function initDesc(desc) {
    // wrap once — the collapsed button pins to this
    var wrap;
    if (desc.hasAttribute('data-pp-desc-ready')) {
      wrap = desc.parentNode;
    } else {
      desc.setAttribute('data-pp-desc-ready', '');
      wrap = document.createElement('div');
      wrap.className = 'pp-desc-wrap';
      desc.parentNode.insertBefore(wrap, desc);
      wrap.appendChild(desc);
    }
    if (!wrap || !wrap.classList.contains('pp-desc-wrap')) return;

    var existing = wrap.querySelector('[data-pp-more]');

    // Desktop prints the description in full — hovering drops the buy panel over this
    // block, so a Read more there could never be clicked. Nothing to expand, no button.
    if (!SHEET_BP.matches) {
      if (existing) existing.parentNode.removeChild(existing);
      desc.classList.remove('is-open');
      wrap.classList.remove('is-open');
      return;
    }
    if (existing) return;

    // Only the browser knows whether the clamp actually truncated anything
    if (desc.scrollHeight <= desc.clientHeight + 1) return;

    var sheet = sheetEl();
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'pp-more';
    more.setAttribute('data-pp-more', '');
    more.textContent = (sheet && sheet.getAttribute('data-more')) || 'Read more';
    wrap.appendChild(more);
  }

  function initCard(card) {
    if (card.hasAttribute('data-ppc-ready')) return;
    card.setAttribute('data-ppc-ready', '');
    selectedIndex(card);
    paintCard(card);
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-ppc]'), initCard);
    Array.prototype.forEach.call(root.querySelectorAll('.pp-plp .product-item-subtitle'), initDesc);
  }

  /* ---------- cart ---------- */

  function revealCart() {
    // Mirror the theme's own drawer chain rather than inventing a third way
    var cartEl = document.querySelector('cart-items');
    if (cartEl && typeof cartEl.getCart === 'function') { cartEl.getCart(); return; }
    if (document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true }));
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location = root + 'cart';
  }

  function addToCart(card, btn, onError) {
    var vid = card.getAttribute('data-vid');
    if (!vid) return;
    var plans = plansOf(card);
    var plan = plans[selectedIndex(card)] || plans[0];

    var item = { id: Number(vid), quantity: 1 };
    if (plan && plan.id) item.selling_plan = plan.id;

    var origLabel = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-busy') || 'ADDING…'; }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Cart error'); });
        return r.json();
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = origLabel; }
        closeSheet();
        revealCart();
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = origLabel; }
        var msg = (err && err.message) || 'Could not add to cart. Please try again.';
        if (onError) onError(msg); else console.error('[ppqa]', msg);
      });
  }

  /* ---------- shared mobile sheet ---------- */

  var sheetCard = null;

  function sheetEl() { return document.querySelector('[data-ppqa]'); }

  function openSheet(card) {
    var el = sheetEl();
    if (!el) return;
    sheetCard = card;

    var thumb = el.querySelector('[data-ppqa-thumb]');
    // data-ppc now sits on the overlay inside the tile, so reach up for the image
    var tile = card.closest('.product-item__image');
    var img = tile ? tile.querySelector('img') : null;
    thumb.textContent = '';
    if (img) {
      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.alt = '';
      thumb.appendChild(clone);
    }

    el.querySelector('[data-ppqa-title]').textContent = card.getAttribute('data-title') || '';
    var view = el.querySelector('[data-ppqa-view]');
    if (view) view.href = card.getAttribute('data-url') || '#';

    var note = el.querySelector('[data-ppqa-note]');
    if (note) { note.hidden = true; note.textContent = ''; }

    var opts = el.querySelector('[data-ppqa-opts]');
    opts.textContent = '';
    var plans = plansOf(card);
    var idx = selectedIndex(card);

    plans.forEach(function (plan, i) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ppqa__opt' + (i === idx ? ' is-selected' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', i === idx ? 'true' : 'false');
      b.setAttribute('data-ppqa-opt', i);

      var radio = document.createElement('span');
      radio.className = 'ppqa__radio';
      var name = document.createElement('span');
      name.className = 'ppqa__opt-name';
      name.textContent = plan.name;
      var price = document.createElement('span');
      price.className = 'ppqa__opt-price';
      price.textContent = plan.price;

      b.appendChild(radio);
      b.appendChild(name);
      b.appendChild(price);
      li.appendChild(b);
      opts.appendChild(li);
    });

    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    var el = sheetEl();
    if (!el || el.hidden) return;
    el.hidden = true;
    sheetCard = null;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function paintSheet() {
    var el = sheetEl();
    if (!el || !sheetCard) return;
    var idx = selectedIndex(sheetCard);
    Array.prototype.forEach.call(el.querySelectorAll('.ppqa__opt'), function (b, i) {
      b.classList.toggle('is-selected', i === idx);
      b.setAttribute('aria-checked', i === idx ? 'true' : 'false');
    });
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (ev) {
    var t = ev.target;

    // --- read more (lives outside the quick-add root, so handle it first) ---
    var moreBtn = t.closest('[data-pp-more]');
    if (moreBtn) {
      // .product-item-subtitle sits inside <a class="product-link">, so this button
      // is nested in an anchor — without this, expanding navigates to the PDP.
      ev.preventDefault();
      ev.stopPropagation();
      var mWrap = moreBtn.closest('.pp-desc-wrap');
      var mDesc = mWrap && mWrap.querySelector('.product-item-subtitle');
      if (mDesc) {
        var isOpen = mDesc.classList.toggle('is-open');
        mWrap.classList.toggle('is-open', isOpen);
        var sh = sheetEl();
        moreBtn.textContent = isOpen
          ? ((sh && sh.getAttribute('data-less')) || 'Read less')
          : ((sh && sh.getAttribute('data-more')) || 'Read more');
      }
      return;
    }

    // --- shared sheet ---

    // VIEW DETAILS. The anchor has a valid href, but the sheet is a modal sitting over
    // the grid and something upstream was eating the default navigation. Driving it
    // explicitly also lets us release the scroll lock first — leaving the page with
    // <html>/<body> still overflow:hidden strands the next page unscrollable if the
    // browser restores it from bfcache.
    var viewLink = t.closest('[data-ppqa-view]');
    if (viewLink) {
      var viewHref = viewLink.getAttribute('href');
      if (viewHref && viewHref.charAt(0) !== '#') {
        ev.preventDefault();
        closeSheet();
        window.location.href = viewHref;
      }
      return;
    }

    if (t.closest('[data-ppqa-close]')) { closeSheet(); return; }

    var sheetOpt = t.closest('[data-ppqa-opt]');
    if (sheetOpt && sheetCard) {
      setPlan(sheetCard, parseInt(sheetOpt.getAttribute('data-ppqa-opt'), 10));
      paintSheet();
      return;
    }

    if (t.closest('[data-ppqa-atc]') && sheetCard) {
      var el = sheetEl();
      var note = el ? el.querySelector('[data-ppqa-note]') : null;
      addToCart(sheetCard, t.closest('[data-ppqa-atc]'), function (msg) {
        if (note) { note.textContent = msg; note.hidden = false; }
      });
      return;
    }

    // --- card ---
    var card = t.closest('[data-ppc]');
    if (!card) {
      // a click anywhere else closes any open dropdown
      closeAllSelects();
      return;
    }
    initCard(card);

    if (t.closest('[data-ppc-sheet-open]')) {
      ev.preventDefault();
      ev.stopPropagation();
      openSheet(card);
      return;
    }

    var toggle = t.closest('[data-ppc-select-toggle]');
    if (toggle) {
      buildOptions(card);
      var sel = card.querySelector('[data-ppc-select]');
      var list = card.querySelector('[data-ppc-opts]');
      var willOpen = list.hidden;
      closeAllSelects();
      list.hidden = !willOpen;
      sel.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    var opt = t.closest('[data-ppc-opt]');
    if (opt) {
      setPlan(card, parseInt(opt.getAttribute('data-ppc-opt'), 10));
      closeAllSelects();
      return;
    }

    if (t.closest('[data-ppc-atc]')) {
      addToCart(card, t.closest('[data-ppc-atc]'));
      return;
    }

    closeAllSelects();
  });

  function closeAllSelects() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppc-opts]'), function (l) { l.hidden = true; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppc-select]'), function (s) { s.classList.remove('is-open'); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppc-select-toggle]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') return;
    closeAllSelects();
    closeSheet();
  });

  // Widening past the sheet breakpoint would strand the scroll lock on desktop
  // crossing the breakpoint changes whether descriptions are clamped at all, so the
  // Read more buttons have to be re-evaluated rather than measured once at load
  var onBp = function () {
    if (!SHEET_BP.matches) closeSheet();
    initAll(document);
  };
  if (SHEET_BP.addEventListener) SHEET_BP.addEventListener('change', onBp);
  else if (SHEET_BP.addListener) SHEET_BP.addListener(onBp);

  /* ---------- boot ---------- */

  function boot() { initAll(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  // Filtering and sorting swap the grid out from under us; re-init whatever lands.
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () { pending = null; initAll(document); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
